// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThemeConfig_themes__fSIlA {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .ThemeConfig_themes__fSIlA {
    grid-template-columns: repeat(2, 1fr);
  }
}

.ThemeConfig_theme__-S2Dm {
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  padding: 2rem;
  background-color: var(--color-grey-7);
  cursor: pointer;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  height: -moz-fit-content;
  height: fit-content;
}
.ThemeConfig_theme__-S2Dm > :first-child {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  margin-bottom: 2rem;
}
.ThemeConfig_theme__active__JKaG3 {
  border: 2px solid var(--color-fash-green-2);
}
.ThemeConfig_theme__-S2Dm:hover, .ThemeConfig_theme__set__bG-MO {
  border: 2px solid var(--color-fash-primary-2);
}
.ThemeConfig_theme__-S2Dm img {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/ThemeConfig/ThemeConfig.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,qCAAA;EACA,SAAA;AADJ;AAGI;EALJ;IAMQ,qCAAA;EAAN;AACF;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,qCAAA;EACA,eAAA;EACA,4CAAA;EACA,wBAAA;EAAA,mBAAA;AAAJ;AAGI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AADR;AAKI;EACI,2CAAA;AAHR;AAMI;EAEI,6CAAA;AALR;AASI;EACI,WAAA;AAPR","sourcesContent":["@import \"../variables/breakpoints\";\n\n.themes {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n\n    @media only screen and (max-width: $bp-600) {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n.theme {\n    display: flex;\n    flex-direction: column;\n    border-radius: 1rem;\n    padding: 2rem;\n    background-color: var(--color-grey-7);\n    cursor: pointer;\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    height: fit-content;\n\n\n    &> :first-child {\n        display: flex;\n        justify-content: space-between;\n        gap: 1rem;\n        align-items: center;\n        margin-bottom: 2rem;\n    }\n\n\n    &__active {\n        border: 2px solid var(--color-fash-green-2);\n    }\n\n    &:hover,\n    &__set {\n        border: 2px solid var(--color-fash-primary-2);\n    }\n\n\n    img {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"themes": `ThemeConfig_themes__fSIlA`,
	"theme": `ThemeConfig_theme__-S2Dm`,
	"theme__active": `ThemeConfig_theme__active__JKaG3`,
	"theme__set": `ThemeConfig_theme__set__bG-MO`
};
export default ___CSS_LOADER_EXPORT___;
